export default {
  closingDay: "Abrechnungstag",
  accountingPeriod: "Abrechnungszeitraum von {{start}}",
  accountingPeriodUntil: " bis {{end}}",
  accountingPeriodStillOpen: " (noch offen)",

  // "Legacy" interpolation mask intentionally still present,
  // as usages without i18next interpolation are required.
  selectionLimit: "Sie können maximal %s Tage auswählen.",

  availableDataToolTip:
    "Die verfügbaren Auswahlmöglichkeiten können je nach ausgewähltem Zeitraum variieren.",
  emptyReportTableText:
    "Es konnten keine Umsätze in dem angegebenen Zeitraum ermittelt werden.",
  emptyActivityTableMessage:
    "Es wurden keine Aktivitäten zu diesen Filterkriterien gefunden.",

  sendReportByMailDialogTitle: "Bericht per E-Mail versenden",
  sendJournalByMailDialogTitle: "Journal per E-Mail versenden",
  successSendMessage: 'Der Bericht wurde an "{{email}}" versendet.',
} as const
